angular.module('tradersyard').service('graph-email-guard', [
    '$http',
    function ($http) {
        /**
         *  @type {String}
         */
        var guard = this;

        guard.url = 'https://api.stopforumspam.org/api';

        /**
         *  @param  {string} options
         *
         *  @return {Function}
         */
        guard.checkEmail = function (email) {
            return $http.get(guard.url, {
                params: {
                    email: email,
                },
            });
        };

        /**
         *  @param  {String} path
         *  @param  {Object} data
         *  @param  {Object} options
         *
         *  @return {Function}
         */
        guard.addUserdToBlacklist = function (url, data, options) {
            return $http.post(guard.url(url), data, extendOptions(options));
        };

        guard.parseResponse = function (response) {
            var xmlParser = new DOMParser();
            var element = xmlParser.parseFromString(response.data, 'text/xml');
            var appears = element.querySelector('appears');
            return appears.textContent;
        };
    },
]);
